import { getDataFromStorage } from "../../libs/auth.helper";
import { sendLoggingInformation } from "../sendLoggingInformation";
import { DEFAULT_VALUE, DEFAULT_VALUE_COUNTRY, EnumActionNameLevel1, EnumActionNameLevel2, EnumActionNameLevel3, EnumGeneratedBy, EnumUxTypes } from "../types/LoggingTypes";
import RoomsCache from "./RoomsCache";
import { updateActionHistory } from "./updateActionHistory";
import { updateWidgetHistory } from "./updateWidgetHistory";
const logSendMessageClick = (pid, oid) => {
    const isSeller = oid === getDataFromStorage().userInfo.id;
    updateActionHistory(EnumActionNameLevel1.MESSAGE, isSeller ? EnumActionNameLevel2.SELLER : EnumActionNameLevel2.BUYER, EnumActionNameLevel3.CLICK);
    updateWidgetHistory('');
    const roomInfo = RoomsCache.getInstance().getRoom(pid);
    sendLoggingInformation({
        uxType: EnumUxTypes.BUTTON,
        actionGeneratedBy: EnumGeneratedBy.USER,
        action_reference_entity: 'post',
        action_reference_id: pid, userTargetId: oid ? oid.toString() : DEFAULT_VALUE,
        post: {
            id: pid,
            service: '',
            category: { label: roomInfo && roomInfo.postCategory && roomInfo.postCategory.length > 0 ? roomInfo.postCategory : DEFAULT_VALUE },
            city: { name: roomInfo && roomInfo.postCountry && roomInfo.postCity.length > 0 ? roomInfo.postCity : DEFAULT_VALUE },
            country: roomInfo && roomInfo.postCountry && roomInfo.postCountry.length > 0 ? roomInfo.postCountry : DEFAULT_VALUE_COUNTRY,
            neighborhoodName: roomInfo && roomInfo.postNeighborhood && roomInfo.postNeighborhood.length > 0 ? roomInfo.postNeighborhood : DEFAULT_VALUE,
            subCategory: roomInfo && roomInfo.postSubCategory && roomInfo.postSubCategory.length > 0 ? roomInfo.postSubCategory : DEFAULT_VALUE
        },
    });
};
const logSendMessageSend = (pid, oid) => {
    setTimeout(() => {
        const isSeller = oid === getDataFromStorage().userInfo.id;
        updateActionHistory(EnumActionNameLevel1.MESSAGE, isSeller ? EnumActionNameLevel2.SELLER : EnumActionNameLevel2.BUYER, EnumActionNameLevel3.SEND);
        updateWidgetHistory('');
        const roomInfo = RoomsCache.getInstance().getRoom(pid);
        sendLoggingInformation({
            uxType: EnumUxTypes.BUTTON,
            actionGeneratedBy: EnumGeneratedBy.USER_SHORTCUT,
            action_reference_entity: 'post',
            action_reference_id: pid,
            userTargetId: oid ? oid.toString() : '',
            post: {
                id: pid,
                service: '',
                category: { label: roomInfo && roomInfo.postCategory && roomInfo.postCategory.length > 0 ? roomInfo.postCategory : DEFAULT_VALUE },
                city: { name: roomInfo && roomInfo.postCountry && roomInfo.postCity.length > 0 ? roomInfo.postCity : DEFAULT_VALUE },
                country: roomInfo && roomInfo.postCountry && roomInfo.postCountry.length > 0 ? roomInfo.postCountry : DEFAULT_VALUE_COUNTRY,
                neighborhoodName: roomInfo && roomInfo.postNeighborhood && roomInfo.postNeighborhood.length > 0 ? roomInfo.postNeighborhood : DEFAULT_VALUE,
                subCategory: roomInfo && roomInfo.postSubCategory && roomInfo.postSubCategory.length > 0 ? roomInfo.postSubCategory : DEFAULT_VALUE
            },
        });
    }, 200);
};
const logScreenLoad = () => {
    updateActionHistory(EnumActionNameLevel1.SCREEN, EnumActionNameLevel2.LOAD, EnumActionNameLevel3.SUCCESS);
    updateWidgetHistory('');
    sendLoggingInformation({ uxType: EnumUxTypes.SCREEN, actionGeneratedBy: EnumGeneratedBy.USER });
};
const logPermissionLocationAllow = () => {
    updateActionHistory(EnumActionNameLevel1.PERMISSION, EnumActionNameLevel2.LOCATION, EnumActionNameLevel3.ALLOW);
    updateWidgetHistory('');
    sendLoggingInformation({ actionGeneratedBy: EnumGeneratedBy.USER, uxType: EnumUxTypes.NA });
};
const logPermissionLocationDeny = () => {
    updateActionHistory(EnumActionNameLevel1.PERMISSION, EnumActionNameLevel2.LOCATION, EnumActionNameLevel3.DENY);
    updateWidgetHistory('');
    sendLoggingInformation({ actionGeneratedBy: EnumGeneratedBy.USER, uxType: EnumUxTypes.NA });
};
export { logPermissionLocationAllow, logPermissionLocationDeny, logSendMessageClick, logSendMessageSend, logScreenLoad };
